export const SAVE_SEARCH = 'SAVE_SEARCH';

export function saveSearch(search) {
  return {
    type: SAVE_SEARCH,
    search,
  };
}
